<mat-table
  [dataSource]="data"
>
  <!-- Product Column -->
  <ng-container matColumnDef="product">
    <mat-header-cell *matHeaderCellDef> Produit </mat-header-cell>
    <mat-cell *matCellDef="let purchase"> {{ purchase.product }} </mat-cell>
  </ng-container>

  <!-- Price Column -->
  <ng-container matColumnDef="price">
    <mat-header-cell *matHeaderCellDef> Prix </mat-header-cell>
    <mat-cell *matCellDef="let purchase">
      <ng-container *ngIf="purchase?.price !== 0; else free">
        {{ purchase?.price! | price | currency }}
      </ng-container>
      <ng-template #free>
        <ng-container>Gratuit</ng-container>
      </ng-template>
    </mat-cell>
  </ng-container>

  <!-- Sales Column -->
  <ng-container matColumnDef="sales">
    <mat-header-cell *matHeaderCellDef> # de Ventes </mat-header-cell>
    <mat-cell *matCellDef="let purchase"> {{ purchase.purchases }} </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>

<mat-paginator
  #myPaginator
  [length]="resultsLength"
  [pageSize]="PAGE_SIZE"
  [hidePageSize]="true"
  [showFirstLastButtons]="true"
></mat-paginator>
